export default __webpack_public_path__ + "static/media/Pricing.a28ad578.jpg";